import { createFileRoute } from '@tanstack/react-router'
import { requireAuth } from '@/lib/auth'
import { RoutePending } from '@/components/route-pending'
import { RouteError } from '@/components/route-error'
import { SalesPage } from './_dashboard.sales'

export const Route = createFileRoute('/_dashboard/sales/')({
  beforeLoad: requireAuth(),
  pendingComponent: RoutePending,
  errorComponent: RouteError,
  component: SalesIndexPage,
})

function SalesIndexPage() {
  return <SalesPage />
}
